/**
 * See [MPEG-DASH XSD](https://standards.iso.org/ittf/PubliclyAvailableStandards/MPEG-DASH_schema_files/DASH-MPD.xsd).
 * This function returns true if the MPD type is static or empty (which is the default value).
 * @param document
 * @returns true if the type is static (default)
 */
export default function(document: Document) {
  const mpd = document.getElementsByTagName('MPD')[0];
  const type = mpd.getAttribute('type');
  return type === 'static' || type === null;
}
